import sjwt from 'jsonwebtoken';

export default (token) => {
  let ret;
  try {
    ret = sjwt.decode(token);
    // const base64Url = token.split('.')[1];
    // const base64 = base64Url.replace('-', '+').replace('_', '/');
    // ret = JSON.parse(window.atob(base64));
  } catch (error) {
    console.log('error jsonwebtoken >>:', error);
    ret = null;
  }
  return ret;
};
